<template>
  <UForm
    :schema="CottageBookmarksSchema"
    :state="state"
    @submit.prevent="submitForm"
  >
    <TText
      classes="mb-2"
      data-test="cottageName"
      size="base"
      variant="semibold"
    >
      {{ t('views.cottage-bookmarks.yourLists') }}
    </TText>

    <UFormGroup
      v-for="item in state"
      :key="item.id"
      :name="item.id.toString()"
      class="form-group py-2"
    >
      <UCheckbox
        v-model="item.value"
        :label="item.label"
        :name="item.id.toString()"
      />
    </UFormGroup>

    <UButton
      class="w-full flex justify-center mt-8"
      variant="concrete"
      size="xl"
      type="submit"
      :disabled="!isValid"
    >
      {{ t('views.cottage-bookmarks.submit') }}
    </UButton>
  </UForm>
</template>

<script setup lang="ts">
import { CottageBookmarksSchema } from '~/modules/views/cottage-bookmarks/entities/CottageBookmarks'
import type { CottageBookmarks } from '~/modules/views/cottage-bookmarks/entities/CottageBookmarks'

// Props
interface propsInterface {
  items: CottageBookmarks
}

const props = defineProps<propsInterface>()

// Emits
const emit = defineEmits(['submit'])
// Constants
const state = reactive(props.items)

const isValid = computed(() => CottageBookmarksSchema.safeParse(state).success)

// Methods
async function submitForm(event: any) {
  const result = CottageBookmarksSchema.safeParse(event.data)
  if (result.success) {
    emit('submit')
  }
}
</script>
